import React from 'react'
import styled from 'styled-components'
import sortBy from 'lodash.sortby'
import { Container } from 'reactstrap'

import TitleBar from '../../atoms/TitleBar'
import NewsList from '../../organisms/NewsList'

const ContainerStatic = styled(Container)`
  margin-top: 6rem;
  padding-bottom: 4rem;
`

const News = ({ news }) =>
  <ContainerStatic>
    <TitleBar>
      menu.news
    </TitleBar>
    <NewsList
      news={sortBy(news.list, 'date').reverse()}
    />
  </ContainerStatic>

export default News



// WEBPACK FOOTER //
// ./src/components/templates/News/News.js